import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface OpeningBalanceKarmaState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpeningBalanceKarmaList: any[];
}

const initialState: OpeningBalanceKarmaState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpeningBalanceKarmaList: [],
};

export const openingBalanceKarmaSlice = createSlice({
  name: "openingBalanceKarma",
  initialState,
  reducers: {
    setOpeningBalanceKarma: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setOpeningBalanceKarmaBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpeningBalanceKarma: (state, action) => {
      state.allOpeningBalanceKarmaList = action.payload.data;
    },
    resetOpeningBalanceKarma: () => initialState,
  },
});



export const {
  setOpeningBalanceKarma,
  setOpeningBalanceKarmaBySearch,
  setAllOpeningBalanceKarma,
  resetOpeningBalanceKarma,
} = openingBalanceKarmaSlice.actions;

export const getOpeningBalanceKarmaData = (state: RootState) => state.openingBalanceKarma.data;
export const getOpeningBalanceKarmaList = (state: RootState) => state.openingBalanceKarma.allOpeningBalanceKarmaList;
export const getOpeningBalanceKarmaTotalRecords = (state: RootState) => state.openingBalanceKarma.totalRecords;
export const getOpeningBalanceKarmaBySearch = (state: RootState) => state.openingBalanceKarma.data;

export default openingBalanceKarmaSlice.reducer;
